(() => {
  const root = document.querySelector('.bg-offer-lp');
  if (!root) return;

  root.querySelectorAll('a[href="#bg-featured-product"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.getElementById('bg-featured-product');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.querySelectorAll('.bg-offer-lp__story-media').forEach((media) => {
    const video = media.querySelector('video');
    const button = media.querySelector('.bg-offer-lp__sound');
    if (!video || !button) return;

    const sync = () => {
      const isOn = !video.muted;
      button.classList.toggle('is-on', isOn);
      button.setAttribute('aria-pressed', String(isOn));
      button.setAttribute('aria-label', isOn ? 'Couper le son' : 'Activer le son');
    };

    button.addEventListener('click', () => {
      video.muted = !video.muted;
      if (video.paused) video.play().catch(() => {});
      sync();
    });

    sync();
  });
})();
